import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

interface BackendConfig {
  name: string;
  url: string;
  username: string;
  password: string;
}

interface PrimaryBackend {
  name: string;
  url: string;
  token: string;
}

const PRIMARY_BACKEND_STORAGE_KEY =
  'primary-admin-auth-backend';

function getConfiguredBackends(): BackendConfig[] {
  const raw = process.env.REACT_APP_BACKENDS;

  if (!raw) {
    return [];
  }

  try {
    let value = raw.trim();

    if (
      value.startsWith("'") &&
      value.endsWith("'")
    ) {
      value = value.slice(1, -1);
    }

    const parsed = JSON.parse(value);

    return Array.isArray(parsed)
      ? parsed
      : [];
  } catch (error) {
    console.error(
      '[I18N] Failed to parse REACT_APP_BACKENDS:',
      error
    );

    return [];
  }
}

function getI18nBackendUrl(): string {
  /*
   * Backend na kojem su uspjele USER credentials
   */
  try {
    const stored =
      localStorage.getItem(
        PRIMARY_BACKEND_STORAGE_KEY
      );

    if (stored) {
      const backend: PrimaryBackend =
        JSON.parse(stored);

      if (backend?.url) {

        return backend.url.replace(/\/$/, '');
      }
    }
  } catch (error) {
    console.error(
      '[I18N] Failed to read primary backend:',
      error
    );
  }

  /*
   * Prije login-a nemamo poznat backend.
   * Koristimo prvi iz REACT_APP_BACKENDS.
   */
  const backends = getConfiguredBackends();

  if (backends.length) {

    return backends[0].url.replace(/\/$/, '');
  }

  console.error(
    '[I18N] No backend configured'
  );

  return '';
}

export const initI18n = (): any => {
  i18n
    .use(initReactI18next)
    .use(Backend)
    .init({
      fallbackLng:
        window.localStorage.getItem('language') ||
        'cg',

      debug: false,

      returnNull: false,

      backend: {
        loadPath: (lngs: string[]) => {
          const backendUrl =
            getI18nBackendUrl();

          const locale =
            lngs?.[0] || 'cg';

          const url =
            `${backendUrl}/vc/api/static/i18n` +
            `?groups=GENERAL,ADMIN,BETS,BET_GROUPS` +
            `&locale=${locale}`;


          return url;
        },

        parse: (data: any) => {
          const parsedData =
            JSON.parse(data);

          return parsedData.data;
        }
      }
    });
};